import React, { useState, useEffect, useRef, createContext } from "react";
import GitchaLogoMobile from "../images/gitchaLogomobile.svg";
import MenuBottomBar from "../components/menuBottomMobile";
import GitchaContentHeaderMob from "../components/GitchaContentHeaderMob";
import PropertyListingHeader from "../components/PropertyListingHeader";
import PropertyListingMob from "../components/PropertyListingMob";
import { favouriteWantAd, unFavouriteWantAd } from "../../services/wantAdService";

import base64 from "base-64";
import utf8 from "utf8";
import {
  BUY,
  WANT_AD_KEY,
  WANT_AD_PAGE_LIMIT,
  USER_INFO_KEY,
  AGENT_WANTAD_KEY,
  HOME_PAGE,
  INVENTORY_KEY,
  STRENGTHEN_WANT_AD_KEY,
  STRENGTHEN_INVENTORY_KEY,
  USER_LOCATION_KEY,
  CLIENT_DETAILS_KEY,
  WANT_AD_ARRAY_KEY,
  LONG_RENT,
  NOTIFICATIONCOUNT,
  INAPPNOTIFICATIONCOUNT,
  SEARCHED_LOCATION,
  FILTER_QUERY,
  SCROLL_DIRECTION_DOWN,
  SCROLL_DIRECTION_UP,
  USER_TYPE_AGENT,
} from "../../constants/common";
import {
  getLocalStorage,
  setLocalStorage,
  loggedInUser,
  removeMultipleLocalStorageItems,
  removeLocalStorage,
  checkTutorialDisplayStatus,
  saveTutorialStatusToLocal,
  clearLocalStorageOnLogout,
  isIphone,
  setBodyBackgroundGrey,
  getUserType,
} from "../../helpers/common";
import wantAds from "../../reducers/wantAds";
import { toast } from "react-toastify";
import { handleTextBoxChange } from "../../actions/common";
import { usePrevious } from "../../hooks/usePrevious";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  saveTutorialStatus,
  checkGitchaAvailable,
} from "../../services/commonServices";
import { pageURLs } from "../../constants/pageURLs";
import {
  getWantAds,
  getAgentsList,
  getUserInventoryCount,
  getGitachGenieMatchedWantAds,
} from "../../services/wantAdService";
import GeoLocation from "../../components/Common/GeoLocation";
import RequestGitchaAvailability from "../../components/Common/RequestGitchaAvailability";
import HomeLoadingSkeleton from "../../pages/HomeLoadingSkeleton";
import GitchaAvailableLocations from "../../components/GitchaAvailableLocationsScreen";
import HeaderMenu from "../components/Common/HeaderMenu";
import {
  getInAppNotications,
  getIntroductions,
} from "../../services/introductionService";
import { convertToNumber } from "../../helpers/validations";
import RequestStayAvailability from "../../components/Common/RequestStayAvailability";
import { useSelector } from "react-redux";
export const filterContext = createContext();
const Home = (props) => {
  const tutorialPage = 1;
  const scrollDivRef = useRef(null);
  const [searchParams] = useSearchParams();
  const AdTypeFromUrl = searchParams.get("AdType");
  const navigate = useNavigate();
  const filterQueryFromStorage = getLocalStorage("filterQuery");
  const browserLocation = getLocalStorage("userLocation");
  const searchedLocation = getLocalStorage(SEARCHED_LOCATION);
  const [inappUnReadCount, setInappUnReadCount] = useState(0);
  const [isPremiumUser , setIsPremiumUser] = useState(null);
  const userDetailsFromStore = useSelector((state)=>state.userProfile.userDetails)
  const userType = getUserType();


  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      if(userDetailsFromStore[0]?.period!==1 && userType===2){
        setIsPremiumUser(true);
      }
      else{
        setIsPremiumUser(false);
      }
    } 
  }, [userDetailsFromStore]);

   // sse data
   let {sseData} = useSelector((state)=>state.sseData);
   const sseTriggedData = sseData?.payload;

  const { notShowGitchaPopup } = props;
  const divRef = useRef(null);
  const handleLogOut = () => {
    clearLocalStorageOnLogout();
    //signOutFirebase();
    navigate(pageURLs.mobileHome);
    window.location.reload();
  };

  const options = [
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
    { value: "highPrice", label: "Highest price" },
    { value: "lowPrice", label: "Lowest price" },
    // { value: "Most Relevant", label: "Most Relevant" },
  ];

  const [currPage, setCurrPage] = useState(1); // storing current page number
  const [adList, setAdList] = useState([]);
  const [adType, setAdType] = useState(AdTypeFromUrl ? AdTypeFromUrl : getLocalStorage("FilterAdtype") ? getLocalStorage("FilterAdtype") : BUY);
  const filterTabKey = getLocalStorage("FilterTabKey");
  const previousBudgetMin = getLocalStorage("priceRangeMatch");
  const locationString = getLocalStorage("LocationString");
  const [totalCount, setTotalCount] = useState(null);
  const user = loggedInUser();
  const [sessionData, setSessionData] = useState(
    getLocalStorage(USER_INFO_KEY)
  );
  const [showFilterPopup, setFilterPopUp] = useState(false);
  const handleFilterPopUpClose = () => setFilterPopUp(false);
  const handleFilterPopUpShow = () => setFilterPopUp(true);
  const [tabCoverHeight, setHeight] = useState(null);
  const [results, setResults] = useState([]);
  const [wasLastPage, setLastPage] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  //form States on  agent client search
  const [formData, setFormData] = useState("");
  const [reloadAgents, setReloadAgents] = useState(false);
  const [showNoResult, setShowNoResult] = useState(false);
  const [offCanvaShow, setOffCanvaShow] = useState(false);
  const handleCanvasClose = () => setOffCanvaShow(false);
  const handleCanvasShow = () => setOffCanvaShow(true);
  const [userLocation, setUserLocation] = useState();
  const [isSearchView, setSearchView] = useState(false);
  const [isGitchaGenieFilter, setIsGitchaGenieFilter] = useState(
    filterTabKey == "match" ? true : false
  );
  const [filterQueryForApply, setFilterQueryForApply] = useState(null);

  const [selectedProperty, setSelectedProperty] = useState(null);
  const [reload, setReload] = useState(false);
  const [sortParam, setSortParam] = useState(options[0]);
  const [wantAdClickCounter, setWantAdClickCounter] = useState(0);
  const [showGitchaNotAvailablePopup, setShowGitchaNotAvailablePopup] =
    useState(false);
  const [gitchaNotAvailble, setGitchaNotAvailable] = useState(null);
  const [showNoPropertyState, setShowNoPropertyState] = useState(false);

  // receive introduction
  const [isLoadIntroList, setLoadIntroList] = useState(false);
  const [introductionList, setIntroductionList] = useState([]);
  const [showIntroList, setIntroList] = useState(true);
  const INTRO_LIST_PAGE_LIMIT = 4;
  const [gitchaAvailableCheckingCompleted, setGitchaAvailableCheckingCompleted] = useState(false);
  const [showRequestStayPopuop, setShowRequestStayPopup] = useState(false);
  
  const handleStayRequestPopupOpen = () =>{
    setShowRequestStayPopup(true);
  }

  const handleStayRequestPopupClose = () => {
    setShowRequestStayPopup(false);
  }
  // un read messages status for handshake icon
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  // un read messages status for handshake icon
  const [unreadNotificationMessageCount, setUnreadNotificationMessageCount] =
    useState(0);
  const wantAdCount = adList?.length
  const handleUserLocation = async (location) => {
    setLocalStorage("userLocation", location);
    if(location?.gitchaAvailable){
      setGitchaNotAvailable(false)
      setGitchaAvailableCheckingCompleted(true)
      if(!locationString || locationString==''){
        if(searchedLocation){ 
          setUserLocation(searchedLocation)
        }
        else {
          setUserLocation(location) 
        }
      }
    }
    else {
    const gitchaAvailablePopupHandled = getLocalStorage(
      "gitchaAvailablePopupHandled"
    );
    const reqPayLoad = {
      county: location.county,
      state: location.state,
    };
    await checkGitchaAvailable(reqPayLoad).then((data) => {
      if (_.get(data, "result") == true) {
        setGitchaAvailableCheckingCompleted(true)
        setGitchaNotAvailable(false);
        if(!locationString || locationString==''){
        if (searchedLocation) {
          setUserLocation(searchedLocation);
        } else {
          setUserLocation(location);
        }
      }
      } else {
        setGitchaAvailableCheckingCompleted(true)
        if(!locationString || locationString==''){
          if (searchedLocation) {
            setUserLocation(searchedLocation);
          } else {
            setUserLocation(null);
          }
        }
        setGitchaNotAvailable(true);
        if (!gitchaAvailablePopupHandled && sessionData) {
          setShowGitchaNotAvailablePopup(true);
        }
      }
    });
  }
  };


  let showNotification = checkTutorialDisplayStatus(tutorialPage);
  const [showNotificationIcon, setNotificationIcon] = useState(false);

  const [gitchaNotAvailableLocation, setGitchaNotAvailableLocation] = useState(null);
  const [fromLocationSearch, setFromLocationSearch] = useState(false);

  const adCount = adList && adList.length;
  const PRICE_MIN = 0;
  const PRICE_MAX = null;
  const SQFT_MIN = null;
  const SQFT_MAX = null;
  const initialQuery =
    adType == "STR"
      ? {
          adType: adType,
          propertyType: [],
          alwpets: null,
          adaAccess: null,
          pvtBath: null,
          pvtEntrance: null,
          typeOfPlace: [10, 11, 6],
          priceMin: PRICE_MIN,
          priceMax: PRICE_MAX,
          sortType: sortParam?.value,
          bedrooms: "",
          beds: "",
          baths: "",
          sqrftMin: SQFT_MIN,
          sqrftMax: SQFT_MAX,
          lat: _.get(userLocation, "latitude", ""),
          long: _.get(userLocation, "longitude", ""),
          // city: _.get(userLocation, "userCity", ""),
          // state: _.get(userLocation, "state", ""),
          search: "",
          page: currPage,
          limit: WANT_AD_PAGE_LIMIT,
          fromDate: null,
          toDate: null,
        
        }
      : adType == "LTR"
      ? {
          adType: adType,
          // location: null,
          propertyType: [],
          typeOfPlace: [10, 11, 6],
          priceMin: PRICE_MIN,
          priceMax: PRICE_MAX,
          sortType: sortParam?.value,
          bedrooms: "",
          baths: "",
          sqrftMin: SQFT_MIN,
          sqrftMax: SQFT_MAX,
          search: "",
          lat: _.get(userLocation, "latitude", ""),
          long: _.get(userLocation, "longitude", ""),
          // city: _.get(userLocation, "userCity", ""),
          // state: _.get(userLocation, "state", ""),
          page: currPage,
          limit: WANT_AD_PAGE_LIMIT,
        
        }
      : {
          adType: adType,
          // location: null,
          propertyType: [],
          priceMin: PRICE_MIN,
          priceMax: PRICE_MAX,
          sortType: sortParam?.value,
          bedrooms: "",
          baths: "",
          sqrftMin: SQFT_MIN,
          sqrftMax: SQFT_MAX,
          lat: _.get(userLocation, "latitude", ""),
          long: _.get(userLocation, "longitude", ""),
          // city: _.get(userLocation, "userCity", ""),
          // state: _.get(userLocation, "state", ""),
          search: "",
          page: currPage,
          limit: WANT_AD_PAGE_LIMIT,
         
        };

  const initialQueryGitchaGenie = {
   
    inventoryId: selectedProperty?.Inv_Id,
    adType: adType,
    city: selectedProperty?.City,
    state: selectedProperty?.State,
    priceMin: PRICE_MIN,
    priceMax: PRICE_MAX,
    sortType: sortParam?.value,
    page: currPage,
    limit: WANT_AD_PAGE_LIMIT,
  };
  const [filterQuery, setFilterQuery] = useState(initialQuery);
  const [filterQueryGitchaGenie, setFilterQueryGitchaGenie] = useState(
    initialQueryGitchaGenie
  );

  let DEFAULT_MAX_BUDGET;
  if (adType === BUY) {
    DEFAULT_MAX_BUDGET = 5000000;
  } else if (adType === LONG_RENT) {
    DEFAULT_MAX_BUDGET = 7500;
  } else {
    DEFAULT_MAX_BUDGET = 5000;
  }

  const priceMinGitchaGenieFromStorage = previousBudgetMin
    ? previousBudgetMin[0]
    : null;
  const priceMaxGitchaGenieFromStorage = previousBudgetMin
    ? previousBudgetMin[1] == DEFAULT_MAX_BUDGET
      ? ""
      : previousBudgetMin[1]
    : null;

  const previousPriceMin = usePrevious(filterQueryGitchaGenie["priceMin"]);
  const previousPriceMax = usePrevious(filterQueryGitchaGenie["priceMax"]);
  const previousUserLocation = usePrevious(userLocation)

  useEffect(() => {
    setFilterQueryForApply(getLocalStorage(FILTER_QUERY))
    //setAdType(BUY);
    //if(!notShowGitchaPopup){
    document.body.classList.add("bg-offcanvas-fix");
    window.addEventListener("scroll", handleScroll); // attaching scroll event listener
  
    //}
    // else{
    //   console.log(`#####notShowGitchaPopup`, notShowGitchaPopup)
    //   document.body.classList.remove("bg-offcanvas-fix");
    // }
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  useEffect(() => {
    if (isGitchaGenieFilter == true) {
      fetchWantAdsMatchingGitchaGenie(filterQueryGitchaGenie);
    }
  }, [isGitchaGenieFilter]);

  useEffect(() => {
    if (!isGitchaGenieFilter) {

      updateQuery({
        lat: _.get(userLocation, "latitude", null),
        long: _.get(userLocation, "longitude", null),
      });
      setCurrPage(1);
      setAdList([]);
    }
  }, [userLocation]);

  useEffect(() => {
    if (!isGitchaGenieFilter && gitchaAvailableCheckingCompleted) {

      setLocalStorage("filterQuery", filterQuery);
      fetchWantAds(filterQuery);
    }
  }, [filterQuery, gitchaAvailableCheckingCompleted]);

  useEffect(() => {
    if (
      isGitchaGenieFilter &&
      (currPage == 1 || (currPage > 1 && adList.length > 0))
    ) {
      fetchWantAdsMatchingGitchaGenie(filterQueryGitchaGenie);
    }
  }, [
    isGitchaGenieFilter,
    filterQueryGitchaGenie.inventoryId,
    filterQueryGitchaGenie.priceMin,
    filterQueryGitchaGenie.sortType,
    filterQueryGitchaGenie.priceMax,
    filterQueryGitchaGenie.page,
    // filterQueryGitchaGenie.adType,
    reload == true,
  ]);

  useEffect(() => {
    updateQuery(filterQueryFromStorage || initialQuery);
    setCurrPage(1);
    setAdList([]);
    let showNotification = checkTutorialDisplayStatus(tutorialPage);
    // setNotificationIcon(showNotification)
  }, [sessionData?.userInfo?.userId]);

  useEffect(() => {
    setTimeout(() => {
      setSessionData(getLocalStorage(USER_INFO_KEY));
    }, 1500);
  }, [user?.token.accessToken]);

  useEffect(() => {
    if (isGitchaGenieFilter) {
      updateQueryGitchaGenie({ page: currPage });
    } else {
      updateQuery({ page: currPage });
    }
  }, [currPage]);
  

  useEffect(() => {
    if (isGitchaGenieFilter) {
      updateQueryGitchaGenie({ sortType: sortParam?.value });
    } else {
      updateQuery({ sortType: sortParam?.value });
    }
    setCurrPage(1);
    setAdList([]);
  }, [sortParam]);

  useEffect(() => {
    updateQueryGitchaGenie({
      inventoryId: selectedProperty?.Inv_Id,
      adType: adType,
      priceMin: priceMinGitchaGenieFromStorage || PRICE_MIN,
      priceMax: priceMaxGitchaGenieFromStorage || PRICE_MAX,
      city: selectedProperty?.City,
      state: selectedProperty?.State,
      sortType: sortParam?.value,
      page: currPage,
      limit: WANT_AD_PAGE_LIMIT,
    });
  
    if (_.get(filterQueryFromStorage, "adType") !== adType) {
      updateQuery(initialQuery);
    } else {
      const filterQueryStorage = filterQueryFromStorage;
      filterQueryStorage["page"] = 1;
      if (filterQueryFromStorage["sortType"] === "newest") {
        setSortParam(options[0]);
      } else if (filterQueryFromStorage["sortType"] === "oldest") {
        setSortParam(options[1]);
      } else if (filterQueryFromStorage["sortType"] === "highPrice") {
        setSortParam(options[2]);
      } else if (filterQueryFromStorage["sortType"] === "lowPrice") {
        setSortParam(options[3]);
      }
      if (!userLocation) {
        filterQueryStorage["lat"] = null;
        filterQueryStorage["long"] = null;
      }
      updateQuery(filterQueryStorage);
    }
    setCurrPage(1);
    setAdList([]);
  }, [adType]);

  const clearFilterQuery = () => {
    removeLocalStorage(SEARCHED_LOCATION);
    removeLocalStorage("filterQuery");
    removeLocalStorage("FilterAdtype");
    if (gitchaNotAvailble) {
      setUserLocation(null);
      setAdList([]);
      initialQuery["lat"] = null;
      initialQuery["long"] = null;
    } else {
      setUserLocation(getLocalStorage("userLocation"));
    }
    setCurrPage(1);
    setAdType(BUY);
    setFilterQuery(initialQuery);
  };
  // console.log("adList", adList)
  const clearFilterGitchaGenie = () => {
    setFilterQueryGitchaGenie(initialQueryGitchaGenie);
  };

  /**
   * function to call Ad list
   * @param {*} query
   */
  const fetchWantAds = async (query) => {  
    console.log("query", query)
    if (_.get(query, "lat", "") && _.get(query, "long", "")) {
      setShowNoResult(false);
      await getWantAds(query)
        .then((response) => {
          const responseResult = _.get(response, "result.data", null);
          setLastPage(responseResult?.length===0)
          setTotalCount(_.get(response, "result.totalCount", "0"));
          if (response.errorCode === 0 && responseResult.length > 0) {
            if(query?.page === 1){
              setAdList(responseResult);
            } else {
              setAdList([...adList, ...responseResult]);
            }
           
          } else if (
            responseResult &&
            responseResult.length === 0 &&
            currPage === 1
          ) {
            setShowNoResult(true);
            setAdList([]);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      setShowNoResult(true);
    }
  };

  const handleShowMoreClick = () => {
    //setShowFooter(false)
    setCurrPage((prevState) => prevState + 1);
  };

  const handleFilterApply = async () => {
    const updatedQuery = { ...filterQuery, ...filterQueryForApply };
    updateFilter(updatedQuery);
    await fetchWantAds(updatedQuery);
    handleFilterPopUpClose();
  };

  const fetchWantAdsMatchingGitchaGenie = async (query) => {
    if(query?.inventoryId){
      setShowNoResult(false);
      await getGitachGenieMatchedWantAds(query)
        .then((response) => {
          const responseResult = _.get(response, "result.data", null);
          setTotalCount(_.get(response, "result.totalCount", "0"));
          if (response.errorCode === 0) {
            if (responseResult?.length > 0) {
              if (
                query.priceMin != previousPriceMin ||
                query.priceMax != previousPriceMax
              ) {
                setAdList([...responseResult]);
              } else {
                setAdList([...adList, ...responseResult]);
              }
            } else if (
              responseResult &&
              responseResult.length === 0 &&
              currPage === 1
            ) {
              setAdList([]);
              setShowNoResult(true);
            }
          } else {
            setAdList([]);
            setShowNoResult(true);
          }
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(err);
        });
    }
    else{
      setShowNoResult(false);
    }
  };

  const handleAdTypeClick = (type) => {
    removeLocalStorage("FilterAdtype");
    removeLocalStorage("filterQuery");
    removeLocalStorage("selectedPropertyId");
    removeLocalStorage("priceRangeMatch");
    setAdType(type);
    if (adType != type) {
      setSelectedProperty(null);
    }
    setLocalStorage("FilterAdtype", type);
  };

  const updateFilter = (stateObject) => {
    const isAdTypeChange = _.get(stateObject, "adType", null);
    if (isAdTypeChange) {
      setAdList([]);
    }
    setCurrPage(1);
    updateQuery(stateObject);
  };

  const updateFilterGitchaGenie = (stateObject) => {
    if (isGitchaGenieFilter) {
      setAdList([]);
      setCurrPage(1);
      updateQueryGitchaGenie(stateObject);
    }
  };

  const updateQuery = (stateObject) => {
    Object.keys(stateObject).map(function (key) {
      setFilterQuery((prevState) => ({
        ...prevState,
        [key]: stateObject[key],
      }));
    });
  };

  const updateQueryGitchaGenie = (stateObject) => {
    Object.keys(stateObject).map(function (key) {
      setFilterQueryGitchaGenie((prevState) => ({
        ...prevState,
        [key]: stateObject[key],
      }));
    });
  };

  const [scrollDirection, setScrollDirection] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const prevScrollPosition = usePrevious(scrollPosition);


  useEffect(() => {
    if(wantAdCount > 2){
      if (scrollPosition > prevScrollPosition && scrollDirection !== SCROLL_DIRECTION_DOWN) {
          setHeight(0);
        //setShowFooter(true)
        setScrollDirection(SCROLL_DIRECTION_DOWN);
      } else if (
        scrollPosition < prevScrollPosition &&
        scrollDirection !== SCROLL_DIRECTION_UP
      ) {
        const currentTab = getLocalStorage("FilterTabKey") || "General";
        if (currentTab === "match") {
          setHeight(divRef.current && divRef.current.clientHeight);
        } else {
          setHeight(divRef.current && divRef.current.clientHeight);
        }
       // setShowFooter(false)
        setScrollDirection(SCROLL_DIRECTION_UP);
      }
    }
  },[scrollPosition])

  
 
  
  // const handleScroll = () => {
  //   const el = scrollDivRef.current;
  //   const scrollHeight = el.scrollHeight;
  //   const scrollTop = el.scrollTop;
  //   const clientHeight = el.clientHeight;
  //   if (
  //     scrollHeight !== clientHeight &&
  //     scrollTop !== 0 &&
  //     Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
  //   ) {
  //     //setCurrPage((prevState) => prevState + 1);
  //   } else if (scrollTop === 0 && scrollHeight !== clientHeight) {
  //     //setCurrPage(prevState => prevState -1);
  //   }
   
  //   if(wantAdCount > 0 && scrollTop!==0 && (scrollHeight !== (scrollTop+clientHeight)) ){
  //     setScrollPosition(scrollTop);
  //   }
  // };
 
  const handleScroll = () => {
    let userScrollHeight = window.innerHeight + window.scrollY;
    let windowBottomHeight = document.documentElement.offsetHeight;
    // if (userScrollHeight >= windowBottomHeight) {
    //   setCurrPage((prevState) => prevState + 1);
    // }
    const isBottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight
 
       if(!isBottom){
      setScrollPosition(window.scrollY);
    }
  };


  // const updateList = () =>{
  //    setAdList([])
  //   setCurrPage(1)
  // }

  /**
   * To handle the want-ad favorite/unfavorite
   */

  const handleFavoriteOrUnfavoriteWantAd = async (
    IsFavourite,
    Want_ad_Id,
    clientId = []
  ) => {
    if (Want_ad_Id) {
      setReload(false);
      let data = {
        clientId: IsFavourite == false ? clientId : null,
        wantAdId: Want_ad_Id,
      };
      await (IsFavourite == false
        ? favouriteWantAd(data)
        : unFavouriteWantAd(data)
      )
        .then((response) => {
          if (response.errorCode == 0) {
            let message = "";
            if (clientId.length > 0) {
              message =
                "Want-ad has been favorited for " +
                clientId.length +
                (clientId.length > 1 ? " clients" : " client");
            } else {
              message =
                IsFavourite == true
                  ? "Want-ad has been removed from your favorites"
                  : "Want-ad has been added to your favorites";
            }

            toast.success(message);
            setCurrPage(1);
            setAdList([]);
            if (isGitchaGenieFilter) {
              setReload(true);
            } else {
              updateQuery(initialQuery);
            }
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  //Remove existing all localStorage keys except userInfo.
  useEffect(() => {
    //setBodyBackgroundGrey()
    removeMultipleLocalStorageItems([
      WANT_AD_KEY,
      INVENTORY_KEY,
      STRENGTHEN_INVENTORY_KEY,
      STRENGTHEN_WANT_AD_KEY,
      USER_LOCATION_KEY,
      CLIENT_DETAILS_KEY,
    ]);
  }, []);

  /**
   *
   */
  useEffect(() => {
    getAgentsClientsList();
  }, [formData, reloadAgents, sessionData?.userInfo?.userId]);

  /**
   * To handle textbox value change on agent client search
   * @param {any} event
   */
  const onChangeText = (event) => {
    let value = "";
    if (event) {
      value = handleTextBoxChange(event);
    }

    setFormData((formData) => value);
  };

  /**
   * To get agents clients list
   * @param {*} query
   */
  const getAgentsClientsList = async (query) => {
    let a = {
      search: formData,
      sortBy: "createdOn",
      sortDir: "desc",
    };
    await getAgentsList(a)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setResults(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const handleWantAdItemClick = (wantAdId) => {
    const sessionUserInfo = getLocalStorage(USER_INFO_KEY);
    console.log("sessionUserInfo", sessionUserInfo);
    if (sessionUserInfo?.userInfo?.userId) {
      setLocalStorage(WANT_AD_KEY, {
        wantAdId: wantAdId,
        isFromHomeFeed: true,
      });
      navigate(pageURLs.viewAd);
    } else {
      //setWantAdClickCounter((prevState) => prevState + 1);
      //const wantAdArray = getLocalStorage(WANT_AD_ARRAY_KEY) || [];
      //if (wantAdArray && wantAdArray.length < 3) {
        const bytes = utf8.encode(
          `abcdefghijklmnopqrstuvwxyz123456789abdefghijklmnopqrstuvwxyz-${wantAdId}-abcdefghijklmnopqrstuvwxyz123456789abdefghijklmnopqrstuvwxyz`
        );
        const encodedId = base64.encode(bytes);
        navigate(`${pageURLs.wantAdPubicMobileDetailsPage}?wantAdId=${encodedId}`);
      }
      // if (!wantAdArray.includes(wantAdId) && wantAdArray.length < 3) {
      //   wantAdArray.push(wantAdId);
      // }
      // setLocalStorage(WANT_AD_ARRAY_KEY, wantAdArray);
    //}
  };

  const showSkeleton = () => {
    return <HomeLoadingSkeleton></HomeLoadingSkeleton>;
  };

  const handleGitchGenieFilter = (value) => {
    if (searchedLocation) {
      setUserLocation(searchedLocation);
    } else {
      if (gitchaNotAvailble) {
        setUserLocation(null);
      } else {
        setUserLocation(getLocalStorage("userLocation"));
      }
    }
    setAdList([]);
    setCurrPage(1);
    // if (value === true) {
    //   updateQueryGitchaGenie({
    //     userId:
    //       sessionData && sessionData.userInfo ? sessionData.userInfo.userId : null,
    //     inventoryId: selectedProperty?.Inv_Id,
    //     adType: adType,
    //     city: selectedProperty?.City,
    //     state: selectedProperty?.State,
    //     priceMin: priceMinGitchaGenieFromStorage || PRICE_MIN,
    //     priceMax: priceMaxGitchaGenieFromStorage || PRICE_MAX,
    //     sortType: sortParam?.value,
    //     page: 1,
    //     limit: WANT_AD_PAGE_LIMIT,
    //   });
    // }
    setIsGitchaGenieFilter(value);
  };

  const handleSortParam = (selectedParam) => {
    setSortParam(selectedParam);
  };
  const getLocationText = () => {
    if (isGitchaGenieFilter) {
      if (selectedProperty != null) {
        return `${totalCount} Matches Want-ads`;
      } else {
        return `${totalCount} Matches Want-ads`;
      }
    } else {
      // return (`${totalCount} Want-Ads In/Near ${_.get(userLocation, "formatted_address", "")}`)
      // return `Want-Ads In/Near ${_.get(userLocation, "formatted_address", "")}`;
      return `Home ${_.get(filterQueryFromStorage,"adType", "") == BUY ? ' Buyers' : 'Renters' }   In/Near  ${_.get(userLocation, "formatted_address", "")}`;
    }
  };

  // const [show, setShow] = useState(false);
  // const handleOnMouseEnter = () => {
  //     setShow(true);
  // }
  // const handleOnMouseLeave = () => {
  //     setShow(false);
  // }
  // const ref = useRef(null);

  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const handleClick = async (event) => {
    setShow(!show);
    setTarget(event.target);
    if (show) {
      let tutorialDisplayedPages = saveTutorialStatusToLocal(1);
      setNotificationIcon(false);
      if (sessionData && sessionData?.userInfo?.userId) {
        await saveTutorialStatus(1, 1); //Save status
      }
    }
  };
  const handleOnMouseEnter = () => {
    setShow(true);
  };
  const handleOnMouseLeave = () => {
    setShow(false);
  };
  const handleToggle = async () => {
    let tutorialDisplayedPages = getLocalStorage("tutorialDisplayedPages");
    tutorialDisplayedPages = tutorialDisplayedPages
      ? tutorialDisplayedPages
      : [];
    tutorialDisplayedPages.push(1); //
    setLocalStorage("tutorialDisplayedPages", tutorialDisplayedPages);
    setNotificationIcon(false);
    if (sessionData && sessionData?.userInfo?.userId) {
      await saveTutorialStatus(1, 1); //Save status
    }
    setShow(false);
  };
  const notificationClass = () => {
    let className = "btn red-hotspot-btn position-absolute";
    if (!showNotificationIcon) {
      className = "btn position-absolute";
    }
    return className;
  };

  useEffect(() => {
    if (
      showNotification === true &&
      sessionData &&
      sessionData?.userInfo?.userId
    ) {
      checkUserInventoryCount();
    }
  }, []);

  const checkUserInventoryCount = async () => {
    let inventoryCount = await getUserInventoryCount();
    const responseResult = _.get(inventoryCount, "result", null);
    setNotificationIcon(false);
    if (inventoryCount.errorCode == 0 && responseResult) {
      if (responseResult[0].count > 0) {
        setNotificationIcon(true);
      }
    }
  };

  useEffect(() => {
    if (sseTriggedData?.messageType == "in-app") {
      getNotificationList();
    } else if (sseTriggedData?.messageType == "receiveIntroduction") {
      const wantAdId = null;
      let page = 1;
      getIntroductionList(page, wantAdId);
    }
  }, [sseTriggedData]);

  useEffect(() => {
    getNotificationList();
    let page = 1;
    let wantAdId = null;
    getIntroductionList(page, wantAdId);
  }, []);
  

  const getNotificationList = async () => {
    const reqPayload = {
    };
    await getInAppNotications(reqPayload).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          if (_.get(response, "result.unReadMessageCount", null) == 0) {
            setLocalStorage(INAPPNOTIFICATIONCOUNT, {
              count: _.get(response, "result.unReadMessageCount", null),
            });
          }
          setUnreadNotificationMessageCount(
            _.get(response, "result.unReadMessageCount", null)
          );
        }
      }
    });
  };

  // receive Intro list
  const getIntroductionList = async (page, wantAdId) => {
    setLoadIntroList(false);
    const reqPayload = {
      wantAdId: wantAdId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        if (response.errorCode === 0) {
          if (_.get(response, "result.unReadMessageCount", null) == 0) {
            setLocalStorage(NOTIFICATIONCOUNT, {
              count: _.get(response, "result.unReadMessageCount", null),
            });
          }
          setUnreadMessageCount(
            _.get(response, "result.unReadMessageCount", 0)
          );
        }
      }
    });
  };


  let mainWrapperClass = "gitcha-main-wrapper windowscroll-fix"
  let contentWrapperClass = "content-wrapper windowscroll-fix h-100 "
  let innerLayoutClass = "inner-layout-header-new bg-white"
  let bottomMenuClass = "inner-layout-footer-new inner-layout-footer-topfix"

  if(isSearchView){
    mainWrapperClass = "gitcha-main-wrapper pb-0"
    contentWrapperClass = "content-wrapper vh-100"
  } else {
    if(wantAdCount > 0){
      if(scrollDirection === SCROLL_DIRECTION_DOWN){
        mainWrapperClass = "gitcha-main-wrapper pad-btm-0 h-100 windowscroll-fix bg-dark-grey-variant"
        contentWrapperClass = "content-wrapper pad-top-0 h-100 windowscroll-fix"
      } else if(scrollDirection === SCROLL_DIRECTION_UP){
        mainWrapperClass = "gitcha-main-wrapper windowscroll-fix"
        contentWrapperClass = "content-wrapper content-wrapper-h-90-percent windowscroll-fix pt-87"
       
      }
    }
  }
  if(wantAdCount > 0){
  if(scrollDirection === SCROLL_DIRECTION_DOWN){
    innerLayoutClass = "inner-layout-header-new bg-white hide-layout-header"
    bottomMenuClass = "inner-layout-footer-new inner-layout-footer-topfix hide-bottom-footer"
  } else if(scrollDirection === SCROLL_DIRECTION_UP){
    innerLayoutClass = "inner-layout-header-new bg-white"
    bottomMenuClass = "inner-layout-footer-new inner-layout-footer-topfix"
  }
}



const NoInventoryForMatch = () =>{
  return(
    <div className={getUserType()===USER_TYPE_AGENT && isPremiumUser? "add-property-listwrap-mob me-3 ms-3 mx-auto mb-30 mt-100" : "add-property-listwrap-mob me-3 ms-3 mx-auto mb-30"}>
                <h6>Why add your property to Gitcha?</h6>
                <ul>
                  <li>
                    <div className="property-wrap-icn-mob">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_18376_82351)">
                          <path
                            d="M19.375 8.75021H17.1938L13.4828 3.64006C13.3704 3.48566 13.224 3.35909 13.055 3.27006C12.886 3.18103 12.6989 3.13191 12.5079 3.12648C12.317 3.12105 12.1274 3.15945 11.9536 3.23873C11.7798 3.318 11.6265 3.43605 11.5055 3.58381L10.5016 4.74787L10.4859 4.76584C10.4278 4.83891 10.3539 4.89793 10.2697 4.93849C10.1856 4.97906 10.0934 5.00012 10 5.00012C9.9066 5.00012 9.8144 4.97906 9.73027 4.93849C9.64613 4.89793 9.57223 4.83891 9.51406 4.76584L9.49844 4.74787L8.49453 3.58381C8.37348 3.43605 8.22018 3.318 8.0464 3.23873C7.87262 3.15945 7.68298 3.12105 7.49205 3.12648C7.30112 3.13191 7.11397 3.18103 6.94498 3.27006C6.77598 3.35909 6.62964 3.48566 6.51719 3.64006L2.80625 8.75021H0.625C0.45924 8.75021 0.300269 8.81606 0.183058 8.93327C0.065848 9.05048 0 9.20945 0 9.37521C0 9.54097 0.065848 9.69994 0.183058 9.81716C0.300269 9.93437 0.45924 10.0002 0.625 10.0002H19.375C19.5408 10.0002 19.6997 9.93437 19.8169 9.81716C19.9342 9.69994 20 9.54097 20 9.37521C20 9.20945 19.9342 9.05048 19.8169 8.93327C19.6997 8.81606 19.5408 8.75021 19.375 8.75021ZM7.52656 4.37521L7.54141 4.39318L8.54531 5.55646C8.72113 5.77265 8.94292 5.94694 9.19455 6.06664C9.44619 6.18634 9.72134 6.24846 10 6.24846C10.2787 6.24846 10.5538 6.18634 10.8054 6.06664C11.0571 5.94694 11.2789 5.77265 11.4547 5.55646L12.4586 4.39318C12.4633 4.38693 12.4664 4.38146 12.4719 4.37521L15.6484 8.75021H4.35078L7.52656 4.37521ZM14.0625 11.2502C13.3708 11.2503 12.7034 11.5054 12.1878 11.9666C11.6723 12.4278 11.3448 13.0628 11.268 13.7502H8.73203C8.65499 13.0634 8.32778 12.429 7.81283 11.9681C7.29787 11.5072 6.63123 11.252 5.94013 11.2512C5.24902 11.2505 4.58182 11.5042 4.06587 11.964C3.54991 12.4238 3.22131 13.0575 3.14278 13.7441C3.06424 14.4308 3.24127 15.1223 3.64008 15.6867C4.03889 16.2511 4.63156 16.649 5.30499 16.8043C5.97843 16.9596 6.68547 16.8615 7.2912 16.5288C7.89693 16.196 8.35894 15.6519 8.58906 15.0002H11.4109C11.5828 15.4864 11.885 15.9159 12.2845 16.2419C12.684 16.5678 13.1655 16.7777 13.6762 16.8485C14.1869 16.9194 14.7073 16.8485 15.1805 16.6435C15.6536 16.4386 16.0613 16.1075 16.359 15.6865C16.6567 15.2655 16.8329 14.7707 16.8684 14.2563C16.9039 13.7419 16.7973 13.2277 16.5603 12.7697C16.3232 12.3118 15.9649 11.9279 15.5243 11.6599C15.0838 11.3919 14.5781 11.2502 14.0625 11.2502ZM5.9375 15.6252C5.62847 15.6252 5.32637 15.5336 5.06942 15.3619C4.81247 15.1902 4.6122 14.9462 4.49394 14.6607C4.37568 14.3751 4.34473 14.061 4.40502 13.7579C4.46531 13.4548 4.61413 13.1764 4.83265 12.9579C5.05117 12.7393 5.32958 12.5905 5.63267 12.5302C5.93577 12.4699 6.24993 12.5009 6.53544 12.6192C6.82095 12.7374 7.06498 12.9377 7.23667 13.1946C7.40836 13.4516 7.5 13.7537 7.5 14.0627C7.5 14.2679 7.45958 14.4711 7.38106 14.6607C7.30254 14.8502 7.18745 15.0225 7.04235 15.1676C6.89726 15.3127 6.72501 15.4278 6.53544 15.5063C6.34587 15.5848 6.14269 15.6252 5.9375 15.6252ZM14.0625 15.6252C13.7535 15.6252 13.4514 15.5336 13.1944 15.3619C12.9375 15.1902 12.7372 14.9462 12.6189 14.6607C12.5007 14.3751 12.4697 14.061 12.53 13.7579C12.5903 13.4548 12.7391 13.1764 12.9576 12.9579C13.1762 12.7393 13.4546 12.5905 13.7577 12.5302C14.0608 12.4699 14.3749 12.5009 14.6604 12.6192C14.946 12.7374 15.19 12.9377 15.3617 13.1946C15.5334 13.4516 15.625 13.7537 15.625 14.0627C15.625 14.4771 15.4604 14.8745 15.1674 15.1676C14.8743 15.4606 14.4769 15.6252 14.0625 15.6252Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_18376_82351">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="property-wrap-text-mob">
                      Private to you and those you introduce it to. No one other
                      than the recipient will see your property.
                    </div>
                  </li>

                  <li>
                    <div className="property-wrap-icn-mob">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.3211 9.74688C19.2937 9.68516 18.632 8.21719 17.1609 6.74609C15.2008 4.78594 12.725 3.75 9.99999 3.75C7.27499 3.75 4.79921 4.78594 2.83905 6.74609C1.36796 8.21719 0.703118 9.6875 0.678899 9.74688C0.643362 9.82681 0.625 9.91331 0.625 10.0008C0.625 10.0883 0.643362 10.1748 0.678899 10.2547C0.706243 10.3164 1.36796 11.7836 2.83905 13.2547C4.79921 15.2141 7.27499 16.25 9.99999 16.25C12.725 16.25 15.2008 15.2141 17.1609 13.2547C18.632 11.7836 19.2937 10.3164 19.3211 10.2547C19.3566 10.1748 19.375 10.0883 19.375 10.0008C19.375 9.91331 19.3566 9.82681 19.3211 9.74688ZM9.99999 15C7.5953 15 5.49452 14.1258 3.75546 12.4023C3.0419 11.6927 2.43483 10.8836 1.95312 10C2.4347 9.11636 3.04179 8.30717 3.75546 7.59766C5.49452 5.87422 7.5953 5 9.99999 5C12.4047 5 14.5055 5.87422 16.2445 7.59766C16.9595 8.307 17.5679 9.11619 18.0508 10C17.4875 11.0516 15.0336 15 9.99999 15ZM9.99999 6.25C9.25831 6.25 8.53329 6.46993 7.9166 6.88199C7.29992 7.29404 6.81927 7.87971 6.53544 8.56494C6.25162 9.25016 6.17735 10.0042 6.32205 10.7316C6.46674 11.459 6.82389 12.1272 7.34834 12.6517C7.87279 13.1761 8.54097 13.5333 9.2684 13.6779C9.99583 13.8226 10.7498 13.7484 11.4351 13.4645C12.1203 13.1807 12.7059 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00576 13.3535 8.05253 12.6505 7.34949C11.9475 6.64645 10.9942 6.25103 9.99999 6.25ZM9.99999 12.5C9.50554 12.5 9.02219 12.3534 8.61107 12.0787C8.19994 11.804 7.87951 11.4135 7.69029 10.9567C7.50107 10.4999 7.45157 9.99723 7.54803 9.51227C7.64449 9.02732 7.88259 8.58186 8.23222 8.23223C8.58186 7.8826 9.02731 7.6445 9.51227 7.54804C9.99722 7.45157 10.4999 7.50108 10.9567 7.6903C11.4135 7.87952 11.804 8.19995 12.0787 8.61107C12.3534 9.0222 12.5 9.50555 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 9.99999 12.5Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="property-wrap-text-mob">
                      Not a live listing on MLS
                    </div>
                  </li>

                  <li>
                    <div className="property-wrap-icn-mob">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.0506 2.5H2.94807C2.60805 2.5 2.28195 2.63743 2.04152 2.88204C1.80109 3.12666 1.66602 3.45844 1.66602 3.80438V16.8482C1.66607 16.9593 1.69406 17.0686 1.74731 17.1657C1.80055 17.2627 1.8773 17.3443 1.97027 17.4027C2.06323 17.4611 2.16932 17.4944 2.27847 17.4994C2.38761 17.5043 2.4962 17.4808 2.5939 17.4311L4.87114 16.2726L7.14839 17.4311C7.23745 17.4764 7.33566 17.5 7.43525 17.5C7.53483 17.5 7.63305 17.4764 7.72211 17.4311L9.99935 16.2726L12.2766 17.4311C12.3657 17.4764 12.4639 17.5 12.5635 17.5C12.663 17.5 12.7613 17.4764 12.8503 17.4311L15.1276 16.2726L17.4048 17.4311C17.5025 17.4808 17.6111 17.5043 17.7202 17.4994C17.8294 17.4944 17.9355 17.4611 18.0284 17.4027C18.1214 17.3443 18.1981 17.2627 18.2514 17.1657C18.3046 17.0686 18.3326 16.9593 18.3327 16.8482V3.80438C18.3327 3.45844 18.1976 3.12666 17.9572 2.88204C17.7167 2.63743 17.3907 2.5 17.0506 2.5ZM17.0506 15.7932L15.4144 14.9601C15.3254 14.9147 15.2271 14.8911 15.1276 14.8911C15.028 14.8911 14.9298 14.9147 14.8407 14.9601L12.5635 16.1193L10.2862 14.9601C10.1972 14.9147 10.0989 14.8911 9.99935 14.8911C9.89976 14.8911 9.80155 14.9147 9.71249 14.9601L7.43525 16.1193L5.158 14.9601C5.06895 14.9147 4.97073 14.8911 4.87114 14.8911C4.77156 14.8911 4.67334 14.9147 4.58428 14.9601L2.94807 15.7932V3.80438H17.0506V15.7932ZM10.6404 8.3697C10.6404 8.19673 10.7079 8.03084 10.8281 7.90853C10.9483 7.78623 11.1114 7.71751 11.2814 7.71751H15.1276C15.2976 7.71751 15.4606 7.78623 15.5808 7.90853C15.701 8.03084 15.7686 8.19673 15.7686 8.3697C15.7686 8.54267 15.701 8.70856 15.5808 8.83087C15.4606 8.95318 15.2976 9.02189 15.1276 9.02189H11.2814C11.1114 9.02189 10.9483 8.95318 10.8281 8.83087C10.7079 8.70856 10.6404 8.54267 10.6404 8.3697ZM10.6404 10.9785C10.6404 10.8055 10.7079 10.6396 10.8281 10.5173C10.9483 10.395 11.1114 10.3263 11.2814 10.3263H15.1276C15.2976 10.3263 15.4606 10.395 15.5808 10.5173C15.701 10.6396 15.7686 10.8055 15.7686 10.9785C15.7686 11.1514 15.701 11.3173 15.5808 11.4396C15.4606 11.5619 15.2976 11.6306 15.1276 11.6306H11.2814C11.1114 11.6306 10.9483 11.5619 10.8281 11.4396C10.7079 11.3173 10.6404 11.1514 10.6404 10.9785ZM4.87114 12.935H8.7173C8.88731 12.935 9.05036 12.8663 9.17057 12.744C9.29079 12.6217 9.35832 12.4558 9.35832 12.2828V7.06532C9.35832 6.89235 9.29079 6.72647 9.17057 6.60416C9.05036 6.48185 8.88731 6.41313 8.7173 6.41313H4.87114C4.70113 6.41313 4.53809 6.48185 4.41787 6.60416C4.29765 6.72647 4.23012 6.89235 4.23012 7.06532V12.2828C4.23012 12.4558 4.29765 12.6217 4.41787 12.744C4.53809 12.8663 4.70113 12.935 4.87114 12.935ZM5.51217 7.71751H8.07627V11.6306H5.51217V7.71751Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="property-wrap-text-mob">
                      Get matched to want-ads
                    </div>
                  </li>

                  <li>
                    <div className="property-wrap-icn-mob">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.8618 2.5032C11.4431 2.52258 11.0261 2.63011 10.637 2.82465C10.6257 2.83028 10.6146 2.83625 10.6036 2.84256L9.42199 3.52534C9.40952 3.52469 9.39704 3.52442 9.38455 3.52452H1.46789C1.38507 3.52335 1.30284 3.53865 1.22598 3.56953C1.14913 3.60042 1.07918 3.64627 1.0202 3.70442C0.961216 3.76257 0.914381 3.83187 0.882414 3.90828C0.850446 3.98469 0.833984 4.06669 0.833984 4.14952C0.833984 4.23235 0.850446 4.31435 0.882414 4.39076C0.914381 4.46717 0.961216 4.53647 1.0202 4.59462C1.07918 4.65277 1.14913 4.69863 1.22598 4.72951C1.30284 4.76039 1.38507 4.77569 1.46789 4.77452H6.78608L6.51427 4.88764C6.50078 4.89314 6.48748 4.89911 6.4744 4.90554C5.78175 5.25187 5.46221 5.98963 5.5312 6.65359C5.60019 7.31755 6.07552 7.97948 6.83735 8.1697C7.13432 8.2437 7.46419 8.28689 7.82368 8.28689C9.64602 8.28689 11.4317 7.71906 11.9602 7.54389C12.3078 7.9319 14.0217 9.84727 14.5945 10.4337C15.0093 10.8582 15.0513 11.2726 14.9444 11.5673C14.8376 11.8621 14.595 12.0898 14.0664 12.0914C13.9228 12.0918 13.7838 12.1417 13.6726 12.2325C13.5615 12.3233 13.485 12.4497 13.456 12.5903C13.3002 13.3439 13.0252 13.4509 12.7447 13.5245C12.4643 13.5981 12.1938 13.5343 12.1938 13.5343C12.1027 13.5094 12.0071 13.5055 11.9142 13.5229C11.8213 13.5403 11.7336 13.5785 11.6576 13.6346C11.5816 13.6908 11.5194 13.7634 11.4755 13.8471C11.4317 13.9308 11.4074 14.0233 11.4044 14.1178C11.4044 14.1178 11.3837 14.4405 11.2246 14.7167C11.0655 14.993 10.8998 15.2259 10.1577 15.1448C10.0002 15.1275 9.84196 15.1706 9.71506 15.2655C9.58815 15.3604 9.50202 15.4999 9.47407 15.6559C9.38902 16.1315 9.13034 16.338 8.74246 16.4095C8.35458 16.4809 7.82784 16.3539 7.36714 15.8984C6.77725 15.3154 4.62641 13.1219 3.65294 12.128C3.22193 11.6879 2.63166 11.4412 2.0172 11.4412H1.46789C1.38507 11.44 1.30284 11.4553 1.22598 11.4862C1.14913 11.5171 1.07918 11.5629 1.0202 11.6211C0.961216 11.6792 0.914381 11.7485 0.882414 11.8249C0.850446 11.9014 0.833984 11.9834 0.833984 12.0662C0.833984 12.149 0.850446 12.231 0.882414 12.3074C0.914381 12.3838 0.961216 12.4531 1.0202 12.5113C1.07918 12.5694 1.14913 12.6153 1.22598 12.6462C1.30284 12.6771 1.38507 12.6924 1.46789 12.6912H2.0172C2.29941 12.6912 2.56372 12.8022 2.7602 13.0029C3.73424 13.9973 5.86478 16.1709 6.48823 16.7871C7.20711 17.4978 8.13408 17.7928 8.9687 17.6391C9.64544 17.5145 10.2381 17.0425 10.5345 16.3696C11.2472 16.3101 11.7948 15.9828 12.1254 15.5924C12.1338 15.5928 12.1423 15.5931 12.1507 15.5932C12.1507 15.5932 14.0315 15.626 15.0779 15.5932C15.8059 15.5706 16.5398 15.3236 17.1873 14.7558C17.4794 14.4999 17.8308 14.357 18.1883 14.357H18.5512C18.634 14.3582 18.7163 14.3429 18.7931 14.312C18.87 14.2811 18.9399 14.2353 18.9989 14.1771C19.0579 14.119 19.1047 14.0497 19.1367 13.9733C19.1687 13.8969 19.1851 13.8149 19.1851 13.732C19.1851 13.6492 19.1687 13.5672 19.1367 13.4908C19.1047 13.4144 19.0579 13.3451 18.9989 13.2869C18.9399 13.2288 18.87 13.1829 18.7931 13.1521C18.7163 13.1212 18.634 13.1059 18.5512 13.107H18.1883C17.4991 13.107 16.8591 13.3818 16.3637 13.8159C15.9087 14.2148 15.5475 14.3283 15.0397 14.344H15.0388C14.6976 14.3547 14.2223 14.3525 13.775 14.3522C14.0938 14.0893 14.3798 13.7073 14.5563 13.1966C15.2783 13.0315 15.8904 12.626 16.1196 11.9938C16.4025 11.2134 16.1824 10.2702 15.4881 9.55968C14.9619 9.02103 12.6259 6.4184 12.6259 6.4184C12.544 6.32696 12.4369 6.26167 12.3181 6.2307C12.1993 6.19973 12.074 6.20444 11.9578 6.24425C11.9578 6.24425 9.57749 7.03689 7.82368 7.03689C7.56401 7.03689 7.33812 7.00648 7.14009 6.95714C6.89067 6.89486 6.79642 6.73336 6.77469 6.5242C6.75308 6.31623 6.82152 6.13262 7.03104 6.02615L8.98742 5.21398C9.01261 5.20338 9.03707 5.19115 9.06066 5.17735L11.1993 3.94119C11.6719 3.70596 12.174 3.68824 12.6292 3.87039L15.4457 4.99669C15.7659 5.12527 16.1076 5.19027 16.4516 5.19037L18.5512 5.19119C18.634 5.19236 18.7163 5.17706 18.7931 5.14618C18.87 5.11529 18.9399 5.06944 18.9989 5.01129C19.0579 4.95314 19.1047 4.88384 19.1367 4.80743C19.1687 4.73102 19.1851 4.64902 19.1851 4.56619C19.1851 4.48336 19.1687 4.40136 19.1367 4.32495C19.1047 4.24854 19.0579 4.17924 18.9989 4.12109C18.9399 4.06294 18.87 4.01708 18.7931 3.9862C18.7163 3.95532 18.634 3.94002 18.5512 3.94119L16.4524 3.94037C16.2667 3.94037 16.0834 3.90584 15.9121 3.83702L15.9104 3.83621L13.0939 2.70991C12.7003 2.55243 12.2804 2.48382 11.8618 2.5032Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="property-wrap-text-mob">
                      Make private introductions to buyers and renters
                    </div>
                  </li>

                  <li>
                    <div className="property-wrap-icn-mob">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.666 6.25H14.166V3.75C14.166 3.41848 14.0343 3.10054 13.7999 2.86612C13.5655 2.6317 13.2475 2.5 12.916 2.5H2.91602C2.5845 2.5 2.26655 2.6317 2.03213 2.86612C1.79771 3.10054 1.66602 3.41848 1.66602 3.75V13.75C1.66638 13.8676 1.69991 13.9827 1.76275 14.0821C1.82559 14.1814 1.91519 14.2611 2.02126 14.3118C2.12733 14.3626 2.24556 14.3824 2.36238 14.369C2.47919 14.3555 2.58985 14.3094 2.68164 14.2359L5.41602 12.0312V14.375C5.41602 14.7065 5.54771 15.0245 5.78213 15.2589C6.01655 15.4933 6.3345 15.625 6.66602 15.625H13.9777L16.9004 17.9859C17.011 18.0754 17.1488 18.1244 17.291 18.125C17.4568 18.125 17.6157 18.0592 17.733 17.9419C17.8502 17.8247 17.916 17.6658 17.916 17.5V7.5C17.916 7.16848 17.7843 6.85054 17.5499 6.61612C17.3155 6.3817 16.9975 6.25 16.666 6.25ZM4.99023 10.7641L2.91602 12.4414V3.75H12.916V10.625H5.3832C5.24016 10.625 5.10145 10.6741 4.99023 10.7641ZM16.666 16.1914L14.5918 14.5141C14.4812 14.4246 14.3434 14.3756 14.2012 14.375H6.66602V11.875H12.916C13.2475 11.875 13.5655 11.7433 13.7999 11.5089C14.0343 11.2745 14.166 10.9565 14.166 10.625V7.5H16.666V16.1914Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="property-wrap-text-mob">
                      Message with tools to transact
                    </div>
                  </li>
                </ul>
              </div>
)}

  const handleGitchaNotAvailableLocation = (location) => {
    setGitchaNotAvailableLocation(location);
    setFromLocationSearch(true);
    setUserLocation(gitchaNotAvailble ? null : browserLocation);  
    setTimeout(()=>{
      setShowGitchaNotAvailablePopup(true)
    }, 300)
  }

  return (
    <>
      {!notShowGitchaPopup && (
        <RequestGitchaAvailability
          show={showGitchaNotAvailablePopup}
          locationFromSTorage={gitchaNotAvailableLocation ? gitchaNotAvailableLocation : browserLocation}
          onHide={() => {
            setShowGitchaNotAvailablePopup(false);
            setGitchaNotAvailableLocation(null);
          }}
          fromLocationSearch={fromLocationSearch}
        />
      )}

      <RequestStayAvailability
      show={showRequestStayPopuop}
      locationFromSTorage={browserLocation}
      onHide={handleStayRequestPopupClose}
      />

      <GeoLocation handleUserLocation={handleUserLocation} page={HOME_PAGE} />

      <div
        className={mainWrapperClass}
      >
        <div
          className={contentWrapperClass}
        >
          <div
            className={showNotificationIcon && isGitchaGenieFilter? innerLayoutClass+" tutorial-header-zindex" :innerLayoutClass}
          >
            <HeaderMenu
              inappUnReadCount={unreadNotificationMessageCount}
              scrollDirection={scrollDirection}
              isFrom="Home"
              setSearchView={setSearchView}
            />
          </div>
          <div
            className="home-layout-content bg-white windowscroll-fix"
            // onScroll={handleScroll}
            // ref={scrollDivRef}
          >
            <div className="select-plan-wrap pl-0 pr-0 pt-0 position-relative windowscroll-fix">
              <GitchaContentHeaderMob
                updateFilter={updateFilter}
                filterQuery={filterQuery}
                clearFilterQuery={clearFilterQuery}
                updateFilterGitchaGenie={updateFilterGitchaGenie}
                handleGitchGenieFilter={handleGitchGenieFilter}
                handleFilterApply={handleFilterApply}
                setSearchView={setSearchView}
                isSearchView={isSearchView}
                showFilterPopup={showFilterPopup}
                handleFilterPopUpClose={handleFilterPopUpClose}
                handleFilterPopUpShow={handleFilterPopUpShow}
                setUserLocation={setUserLocation}
                userLocation={userLocation}
                gitchaNotAvailble={gitchaNotAvailble}
                searchedLocation={searchedLocation}
                setFilterQueryForApply={setFilterQueryForApply}
                filterQueryForApply={filterQueryForApply}
                scrollDirection={scrollDirection}
                setHeight={setHeight}
                wantAdCount = {wantAdCount}
                setAdType ={setAdType}
                divRef = {divRef}
                showNotificationIcon={showNotificationIcon}
                setNotificationIcon={setNotificationIcon}
                setShowNoPropertyState={setShowNoPropertyState}
                handleStayRequestPopupOpen={handleStayRequestPopupOpen}
                handleGitchaNotAvailableLocation={handleGitchaNotAvailableLocation}
              />

              {!isSearchView && (
                <div
              
                  className="adListWrap pb-0 windowscroll-fix bg-grey-variant"
                  style={{ paddingTop: tabCoverHeight }}
                >
                  {showNoResult && adList && adList.length  === 0 ? (
                    <></>
                  ) : (
                    <>
                      <PropertyListingHeader
                        title={
                          gitchaNotAvailble == true &&
                          !userLocation &&
                          !isGitchaGenieFilter
                            ? browserLocation
                              ? browserLocation?.city +
                                ", " +
                                browserLocation?.state
                              : "Location isn't available"
                            : totalCount != null
                            ? getLocationText()
                            : ""
                        }
                        sortParam={sortParam}
                        handleSortParam={handleSortParam}
                        isGitchaGenieFilter={isGitchaGenieFilter}
                        selectedProperty={selectedProperty}
                      />
                    </>
                  )}

                  {gitchaNotAvailble == true &&
                  !userLocation &&
                  !isGitchaGenieFilter ? (
                    <div className="no-result-wrap no-result-wrap-pad">
                      <GitchaAvailableLocations
                        setUserLocation={setUserLocation}
                      />
                    </div>
                  ) : 
                  showNoResult && adList && adList.length === 0  ? (
                    !isGitchaGenieFilter ?
                    (
                    <div className="no-result-wrap no-result-wrap-pad">
                      <>
                        <h3>There aren't any want-ads in your location yet</h3>
                        <p>
                          In the mean time, try broadening your location search
                        </p>
                      </>
                    </div>
                    )
                    :
                    (
                      <div className="no-result-wrap no-result-wrap-pad">
                      <>
                        <h3>It looks like your property doesn’t have any matches yet, but we’ll notify you as soon as you have a match!</h3>
                        <p>
                        In the meantime, you can add another property or post a want-ad.
                        </p>
                      </>
                    </div>
                    )
                  ) : !showNoResult && adList && adList.length === 0 ? (
                    isGitchaGenieFilter && selectedProperty===null && showNoPropertyState ?
                    <NoInventoryForMatch/>
                    :<>
                      <div className="property-listing-outer">
                        {/* <HomeLoadingSkeleton /> */}
                      </div>
                    </>
                  ) : (
                    <>
                      {adList &&
                        adList.map((wa, index) => (
                          <PropertyListingMob
                            list={wa}
                            key={index}
                            handleFavoriteOrUnfavoriteWantAd={
                              handleFavoriteOrUnfavoriteWantAd
                            }
                            results={results}
                            clientSearchText={formData}
                            onChangeText={onChangeText}
                            onAddClient={() => setReloadAgents(!reloadAgents)}
                            handleWantAdItemClick={handleWantAdItemClick}
                          />
                        ))}

                    
                          {wantAdCount!== totalCount ? <div className="listing-btn-wrap">
                          <button className="btn btn-primary" onClick={()=>handleShowMoreClick()}>Show More</button>
                        </div>
                        
                        : <div className="listing-lastrecord-spacing"></div>
                          }
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {!isSearchView && (
          <div
            className={bottomMenuClass}
          >
            <div className="bottomMenu bottom-menu-index">
              <MenuBottomBar
                unreadNotificationMessageCount={unreadMessageCount}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
